import { Component, OnInit, Input, SimpleChanges, forwardRef } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { MarvSelectComponent, MarvSelectItem } from '@marv/components';
import { OperationService } from '@app/services';

@Component({
    selector: 'app-permanent-operation-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [forwardRef(() => MarvSelectComponent)]
})
export class PermanentOperationSelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelSelect: string = this.translateService.instant('PERMANENT_OPERATION');
    @Input({alias : 'icon', required : false}) iconSelect: string = 'briefcase-outline';
    @Input({alias : 'formName', required : false}) formName: string|number = 'permanentOperationId';
    @Input({alias : 'errorText', required : false}) errorText: string = '';
    @Input({alias : 'multiple', required : false}) multiple: boolean = false; 
    @Input({alias : 'displayItemsSelected', required : false}) displayItemsSelected: boolean = false;
    @Input({alias : 'operations', required : false}) operations: Array<MarvSelectItem>;

    items: Array<MarvSelectItem> = [];

    constructor(
        public translateService: TranslateService,
        private operationService: OperationService
    ) { }

    async ngOnInit() {
        let items: Array<MarvSelectItem> = [];
        if(typeof this.operations !== 'undefined'){
            items = this.operations;
        }
        else{
            let operations = await this.operationService.loadPermanentsOperations();
            if(operations){
                for(let operation of operations){
                    items.push(new MarvSelectItem(operation.title,operation.id));
                }
            }
        }
        this.items = items;
    }
    
    async ngOnChanges(changes: SimpleChanges) {      
        if(changes['operations'] && changes['operations'].currentValue){ 
            if(typeof this.operations !== 'undefined'){
                this.items = this.operations;
            }
        }
    }

}
